import { Icon, IconsEnum } from 'components/Icons';
import { AnchorLink } from 'components/anchorLink';
import React from 'react';
import styles from './TitleBar.module.scss';

export type TitleBarProps = {
  bgcolor?: 'dark' | 'light' | 'transparent';
  greet?: string;
  title: string;
  titleIcon?: JSX.Element;
  subTitle?: string;
  goToLink?: string;
  className?: string;
  noPaddingBottom?: string;
  paddingTop?: string;
  containerClassName?: string;
};

export const TitleBar: React.FC<TitleBarProps> = ({
  bgcolor = 'dark',
  greet,
  title,
  titleIcon,
  subTitle,
  goToLink,
  className,
  noPaddingBottom,
  paddingTop,
  containerClassName,
}: TitleBarProps) => {
  if (!!title) {
    return (
      <div
        className={`${styles.titleContainer} ${bgcolor} ${styles[noPaddingBottom!]} ${styles[paddingTop!]} ${
          containerClassName ?? ''
        }`}
      >
        <div className={styles.titleIcon}>{titleIcon}</div>
        <div className={styles.titleText}>
          <div className={styles.greet}>{greet}</div>
          <div className={`${styles[className!]} ${styles.title}`} id="userId">
            {title}
          </div>
          <div>{subTitle && goToLink && <AnchorLink href={goToLink}>{subTitle}</AnchorLink>}</div>
        </div>
        <div className={styles.goToContainer}>
          {goToLink && (
            <AnchorLink href={goToLink}>
              <div className={styles.goTo}>
                <Icon
                  iconId={IconsEnum.GOTO_ARROW}
                  /* id={toIconsEnum(arrow)} */
                  className={styles.icon}
                  color="var(--color-primary)"
                />
              </div>
            </AnchorLink>
          )}
        </div>
      </div>
    );
  }
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
};
